import React from 'react';
import List from '../components/NewList'

const OutToDoProcess = () => <List bidding_process_stage="TO_DO_PROCESS" />

export default OutToDoProcess;